var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_1983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7819 6.34927C15.1537 6.34927 14.488 5.12879 15.2976 3.63179C15.7654 2.7641 15.4865 1.65804 14.6679 1.16222L13.1117 0.218258C12.401 -0.229888 11.4835 0.0370925 11.0607 0.790358L10.9618 0.971523C10.1522 2.46852 8.82084 2.46852 8.00225 0.971523L7.9033 0.790358C7.4985 0.0370925 6.58096 -0.229888 5.87031 0.218258L4.31409 1.16222C3.4955 1.65804 3.21664 2.77364 3.68441 3.64133C4.503 5.12879 3.83733 6.34927 2.20915 6.34927C1.27361 6.34927 0.5 7.15974 0.5 8.16092V9.83908C0.5 10.8307 1.26462 11.6507 2.20915 11.6507C3.83733 11.6507 4.503 12.8712 3.68441 14.3682C3.21664 15.2359 3.4955 16.342 4.31409 16.8378L5.87031 17.7817C6.58096 18.2299 7.4985 17.9629 7.92129 17.2096L8.02024 17.0285C8.82983 15.5315 10.1612 15.5315 10.9798 17.0285L11.0787 17.2096C11.5015 17.9629 12.419 18.2299 13.1297 17.7817L14.6859 16.8378C15.5045 16.342 15.7834 15.2264 15.3156 14.3682C14.497 12.8712 15.1627 11.6507 16.7909 11.6507C17.7264 11.6507 18.5 10.8403 18.5 9.83908V8.16092C18.491 7.16928 17.7264 6.34927 16.7819 6.34927ZM9.4955 12.0989C7.88531 12.0989 6.57196 10.7068 6.57196 9C6.57196 7.29323 7.88531 5.90112 9.4955 5.90112C11.1057 5.90112 12.419 7.29323 12.419 9C12.419 10.7068 11.1057 12.0989 9.4955 12.0989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_1983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7206814f84b8b9493b6b7bf9a70e0481.svg";
export { ForwardRef as ReactComponent };